import { remove } from './remove';

/** helper function to add item to array, overwriting existing entry*/
export const add = <P>(array: P[] = [], item: P) => {
  return [...remove(array, item), item];
};
